const changeFormatOfDate = (date, format) => {
  const dateToChange = new Date(date);
  const formatedDate =
    format === 'dd/mm/yy'
      ? dateToChange.toLocaleDateString('es-AR')
      : `${dateToChange.toLocaleDatARtring('es-AR', {
          weekday: 'long'
        })} ${dateToChange.getDate()}`;

  return formatedDate.charAt(0).toUpperCase() + formatedDate.slice(1);
};

const setInputBackgroundColor = (colors) => colors.split(',')[1];
const setInputColor = (colors) => colors.split(',')[0];

const addQuantities = (objectOfUbications, quantities, activeDates, isOyM) => {
  const auxObject = {};

  quantities.forEach((quantity) => {
    auxObject[changeFormatOfDate(new Date(quantity.fecha), 'dd/mm/yy')] = {
      colors: {
        backgroundColor: setInputBackgroundColor(quantity.color),
        textColor: setInputColor(quantity.color)
      },
      stateOfUnitMeasure: quantity.estadoEnum,
      unitMeasureValue: quantity.cantidad,
      dailyPartJobLineId: quantity.idParteTrabajoDiario,
      date: quantity.fecha,
      isOutWindowNotification: !isOyM
        ? !activeDates.some((activeDate) => activeDate === quantity.fecha)
        : false,
      enableNotification: quantity.habilitaNotificacion,
      disabled: objectOfUbications?.rowDefiner?.ubicationFinished,
      disabledBySap: objectOfUbications?.rowDefiner?.lineBlockedBySap
    };
  });

  return {
    ...objectOfUbications,
    ...auxObject
  };
};

const buildChildrenOfUbications = ({
  tipoEvento,
  nombreEquipo,
  fechasEvento,
  ubicationId,
  ubicationName,
  numberOfLines,
  partJobLine,
  rangesOfUbications,
  activeDates,
  isOyM,
  idsEventoPozo,
  ubicationFinished
}) => {
  const objectToReturn = {
    group: {
      ubicationName,
      ubicationId,
      numberOfLines,
      firstRowIndex: rangesOfUbications.initialRange,
      lastRowIndex: rangesOfUbications.finalRange,
      tipoEvento,
      nombreEquipo,
      fechasEvento,
      idsEventoPozo,
      ubicationFinished,
      lineBlockedBySap: partJobLine?.bloqueadoEnSap
    },
    rowDefiner: {
      nameLine: partJobLine?.nombreLineaSap,
      namePosition: partJobLine?.nombrePosicionSap,
      partJobLineId: partJobLine?.idParteTrabajoLinea,
      numberLine: partJobLine?.numeroLinea,
      numberPosition: partJobLine?.numeroPosicion,
      unitMeasurement: partJobLine?.unidadMedida,
      ubicationFinished,
      lineBlockedBySap: partJobLine?.bloqueadoEnSap
    }
  };

  return addQuantities(objectToReturn, partJobLine.cantidades, activeDates, isOyM);
};

const buildChildrenOfPartJobLine = (
  nameLine,
  namePosition,
  numberLine,
  numberPosition,
  numberOfLines,
  unitMeasureValue,
  partJobLineId,
  ubication,
  ranges,
  isOyM,
  lineBlockedBySap
) => {
  const objectToReturn = {
    group: {
      nameLine,
      namePosition,
      partJobLineId,
      numberOfLines,
      numberLine,
      numberPosition,
      firstRowIndex: ranges.initialRange,
      lastRowIndex: ranges.finalRange,
      unitMeasurement: unitMeasureValue,
      lineBlockedBySap
    },
    rowDefiner: {
      ubicationName: ubication.ubicacionNombre,
      ubicationId: ubication.idUbicacion,
      ubicationFinished: ubication?.finalizada,
      lineBlockedBySap
    }
  };

  return addQuantities(objectToReturn, ubication.cantidades, ubication.fechasActivas, isOyM);
};

export { buildChildrenOfPartJobLine, buildChildrenOfUbications };
